import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";
import { NotificationBellHost } from "@amtana/notification-client";
import { UNSUBSCRIBE_SCREEN_PATH } from "@amtana/notification-contract";

import { NOTIFICATION_CATALOGS, NOTIFICATION_ERROR_COPY } from "./model/notification-copy.ts";

export const notificationBrowserModule: BrowserModule = defineBrowserModule("notification")
  .withErrorCopy(NOTIFICATION_ERROR_COPY)
  .withScreens({
    settings: {
      path: "/settings/notifications",
      title: phrase(NOTIFICATION_CATALOGS, "screenTitleSettings"),
      layout: "app",
      load: () => import("./ui/sections/notification-settings-screen.tsx"),
    },
    // Where a mailed unsubscribe link lands, signed in or not (email-delivery.feature).
    unsubscribe: {
      path: UNSUBSCRIBE_SCREEN_PATH,
      title: phrase(NOTIFICATION_CATALOGS, "screenTitleUnsubscribe"),
      layout: "auth",
      load: () => import("./ui/sections/unsubscribe-screen.tsx"),
    },
  })
  .withLends([{ token: NotificationBellHost, load: () => import("./ui/blocks/notification-bell-host.tsx") }])
  .withNavigation([
    {
      id: "notifications",
      group: "settings-you",
      label: phrase(NOTIFICATION_CATALOGS, "notificationsTitle"),
      href: "/settings/notifications",
      icon: "bell",
      order: 810,
    },
  ]);
